import { useCallback } from 'react';
import {
  getPassportTypeDictSelector,
  getLeaveTypeDictSelector,
  getSalaryTypeDictSelector,
  getRequestTypeDictSelector,
  getITReqItemsDictSelector,
  getAttendanceTypesDict,
} from '@Store/selectors/dictionarySelector';
import { TypeDict } from 'types';
import RequestType from '@Types/common/RequestTypes';
import { useAppSelector } from '.';

type RequestTypeFinder = Extract<
  RequestType,
  'Leave' | 'Passport' | 'Salary' | 'ITRequisition' | 'Material' | 'Attendance'
>;

interface ReturnedValue {
  findRequestType: (requestTypeID: number) => TypeDict | undefined;
}

const mapperTypesDictionary = {
  Leave: getLeaveTypeDictSelector,
  Passport: getPassportTypeDictSelector,
  Salary: getSalaryTypeDictSelector,
  ITRequisition: getITReqItemsDictSelector,
  Material: getRequestTypeDictSelector,
  Attendance: getAttendanceTypesDict,
};

const useRequestTypeFinderById = (
  requestType: RequestTypeFinder
): ReturnedValue => {
  const dictionaryTypes = useAppSelector(mapperTypesDictionary[requestType]);

  const findRequestType = useCallback(
    (requestTypeID: number): TypeDict | undefined =>
      dictionaryTypes.find((item) => item.codeNum === requestTypeID),
    [dictionaryTypes]
  );

  return { findRequestType };
};

export default useRequestTypeFinderById;
